var parser = document.createElement('a')

module.exports = function (url) {
  parser.href = url
  return parser.hostname
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/filters/domain.js
 ** module id = 78
 ** module chunks = 0
 **/